<h2 mat-dialog-title>Multiple persons found, please select one:</h2>
<mat-dialog-content>
    <mat-radio-group (change)="onSelect($event.value)">
        @for(person of persons; track person.personId) {
        <app-person-selection-item [person]="person"></app-person-selection-item>
        }
    </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-raised-button [mat-dialog-close]="selectedPerson" [disabled]="!selectedPerson" class="select-button"
        color="primary">Select</button>
</mat-dialog-actions>